export const options = {
    API_KEY_MAPBOX: 'pk.eyJ1Ijoidmhham1payIsImEiOiJjam90bGJzMmMxMmh3M2tybmljb2o4YmtzIn0.qU5_ExGJNUGpTTtdpZ1X0w'
};

export const URL_TRAVEL = 'https://0v9d5l44y4.execute-api.us-east-1.amazonaws.com/test/travel?%24filter=';
export const URL_SIGHTS = 'https://0v9d5l44y4.execute-api.us-east-1.amazonaws.com/test/sight?%24filter=';